import styled from 'styled-components';

import { Button } from 'src/components/core';
import { Typography } from 'src/typography';
import { TruncateText } from 'src/payments/components';

type BankLogoProps = {
  width?: string;
  height?: string;
};

export const StyledTitle = styled(Typography.Title)`
  color: ${({ theme }) => theme.colors.primaryBlack};
  margin: 40px 0 20px;
`;

export const BankWrapper = styled.div<{ wrapButton?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.grey[90]}};
  color: ${({ theme }) => theme.colors.grey[70]};
  justify-content: space-between;
  padding: 20px 16px;
  gap: 24px;

  ${({ theme }) => theme.breakpoints.down('xs')} {
    align-items: ${({ wrapButton }) => (wrapButton ? `start` : `center`)};
    flex-direction: ${({ wrapButton }) => (wrapButton ? `column` : `row`)};
    gap: 0;
  }
`;

export const ErrorWrapper = styled.div`
  display: flex;
  align-items: start;
  background: transparent;
  border: 0;
  color: ${({ theme }) => theme.colors.red[55]};
  cursor: pointer;
  font-weight: bold;
  gap: 6px;
  margin-top: 4px;
  padding: 0;
  text-align: left;

  & > svg {
    margin-top: -1px;
    min-width: 15px;
  }
`;

export const BankInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  font-size: 12px;
`;

export const BankInfoInner = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.grey[45]};
  gap: 12px;
`;

export const BankLogo = styled.img<BankLogoProps>`
  width: ${({ width }) => width || '36px'};
  height: ${({ height }) => height || '36px'};
`;

export const BankTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BankName = styled(TruncateText)`
  color: ${({ theme }) => theme.colors.primaryBlack};
  font-size: 14px;
  font-weight: bold;
  line-height: 16px;
`;

export const BankDetail = styled.span`
  white-space: nowrap;
  line-height: 20px;
`;

export const RelinkButton = styled(Button)`
  background: ${({ theme }) => theme.colors.dutchiePayGreen};

  ${({ theme }) => theme.breakpoints.down('xs')} {
    width: 100%;
    margin-top: 20px;
  }
`;

export const EditButton = styled.button`
  background: transparent;
  border: 0;
  color: ${({ theme }) => theme.colors.dutchiePayGreen};
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  margin: 0 0 0 4px;
  padding: 0;
  text-transform: uppercase;
`;
